<!-- <div
  class="overflow"
  *ngIf="(ngb.currentEditingBlock$ | async) !== block"
  (click)="uploadImage()"
>
  <mat-icon inline>cloud_upload</mat-icon>
</div> -->
<img [src]="src" [title]="block.options.title" [ngStyle]="getImageStyles()" />
